import React from 'react';

function NextIcon(props) {
  return (
    <svg width='7' height='12' viewBox='0 0 7 12' xmlns='http://www.w3.org/2000/svg' className='next-icon'>
      <g strokeWidth='2' stroke='#333' fill='none' fillRule='evenodd' strokeLinecap='round'>
        <path d='M6 6L1 1.5M1 11l5-4.5'/>
      </g>
    </svg>
  );
}

export default NextIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/NextIcon.js